import { Component, OnInit, OnDestroy } from '@angular/core';
import { BookingService } from '../services/booking.service';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Subscription } from 'rxjs';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogConfig as MatDialogConfig,
} from '@angular/material/legacy-dialog';
import { AlertDialogComponent } from '../components/shared/alert-dialog/alert-dialog.component';
import { ErrorDialogComponent } from '../components/shared/error-dialog/error-dialog.component';

@Component({
  selector: 'app-booking-history',
  templateUrl: './booking-history.component.html',
  styleUrls: ['./booking-history.component.scss'],
})
export class BookingHistoryComponent implements OnInit, OnDestroy {
  isGroomRoom = environment.GROOM;
  isRequestClinic: boolean;
  error$ = new BehaviorSubject<string>(null);
  private errorSub: Subscription;

  constructor(public bookingService: BookingService, public dialog: MatDialog) {
    this.isRequestClinic = bookingService.isRequestClinic;
  }

  ngOnInit(): void {
    this.bookingService.editingAppointment$.next(null);
    this.errorSub = this.bookingService.error$.subscribe((error) => {
      if (error) {
        const errorDialogConfig = new MatDialogConfig();
        errorDialogConfig.data = {
          title: 'Appointment Booking Error',
          error,
        };
        this.dialog.open(ErrorDialogComponent, errorDialogConfig);
      }
    });
  }

  ngOnDestroy(): void {
    this.errorSub?.unsubscribe();
  }
}
